import { isNil, reject } from "ramda";
export function processImageTransforms(input) {
    if (typeof input === "number") {
        return {
            width: input,
            height: input,
            //  aspectRatio: [1, 1] as const,
        };
    }
    return input ?? {};
}
export function imageTransformsToUrl(rootImageUrl, companyId, id, input) {
    const transforms = processImageTransforms(input);
    const params = {
        optimizer: "image",
        aspect_ratio: transforms.width && transforms.height ? transforms.width + ":" + transforms.height : undefined,
        width: transforms.width,
        height: transforms.height,
        format: transforms.format,
        quality: transforms.quality,
    };
    return rootImageUrl + "/" + companyId + "/" + id + "?" + Object.entries(reject(isNil, params)).map(_ => _[0] + "=" + encodeURIComponent(_[1])).join("&");
}
